import { Emitter } from './emitter';

/**
 * Ambient light sensor, used to flip the UI to dark mode in the dark.
 * Chrome only, and only with chrome://flags#enable-generic-sensor-extra-classes
 * enabled: https://chromestatus.com/feature/4636879949398016
 */
class Ambient extends Emitter<boolean> {
  sensor: AmbientLightSensor | null = null;

  start() {
    if (this.sensor !== null || !('AmbientLightSensor' in window)) {
      return;
    }

    navigator.permissions
      .query({ name: 'ambient-light-sensor' as PermissionName })
      .then((result) => {
        if (result.state === 'denied') {
          return;
        }
        const sensor = new AmbientLightSensor({ frequency: 0.25 });
        sensor.addEventListener('reading', () => {
          this.emit(sensor.illuminance < 3);
        });
        sensor.start();
        this.sensor = sensor;
      })
      .catch(() => {
        // Sensor unavailable (unsupported permission name, insecure context, …)
      });
  }
}

export default new Ambient();
